import DataTable from "react-data-table-component"
import DataTableExtensions from 'react-data-table-component-extensions'
import "react-data-table-component-extensions/dist/index.css"
import { useTranslation } from "react-i18next"

export const CustomDataTable = (props) => {
    const { t } = useTranslation()

    const {
        columns,
        data,
        exportable,
        printable,
        expandedData,
        paginationServer = false,
        disableExtensions = false,
        ...tableProps
    } = props

    const commonTableProps = {
        className: "table table-sm table-striped table-bordered table-hover customtable",
        noDataComponent: t('datatables.sinresultados'),
        labelRowsPerPage: t('datatables.elementosporpagina'),
        defaultSortField: "creationDate",
        defaultSortAsc: false,
        expandableRows: !!expandedData,
        expandableRowsComponent: expandedData ? expandedData : undefined,
        pagination: true,
        paginationRowsPerPageOptions: [10, 25, 50, 100],
        paginationPerPage: 25,
        paginationComponentOptions: {
            rowsPerPageText: t('datatables.elementosporpagina'),
            rangeSeparatorText: t('datatables.de'),
            noRowsPerPage: false,
            selectAllRowsItem: true,
            selectAllRowsItemText: t('datatables.todos')
        },
        ...tableProps,
        columns,
        data
    }

    const tableData = {
        columns: columns,
        data: data,
        exportHeaders: true,
        print: printable,
        export: exportable,
        filterPlaceholder: t('datatables.buscar'),
        filterDigit: 2
    }

    if (paginationServer || disableExtensions) {
        return <DataTable {...commonTableProps} paginationServer={paginationServer} />
    }

    return (
        <>
            <DataTableExtensions {...tableData}>
                <DataTable {...commonTableProps} />
            </DataTableExtensions>
        </>
    )
}